import React from "react"

import { ChildrenDisabler } from "@atos6/ui"
import { useStore } from "../containers"

export function ChildrenDisablerStateful(props: React.PropsWithChildren<{}>) {
  const { active } = useStore()

  return (
    <ChildrenDisabler disabled={!active}>{props.children}</ChildrenDisabler>
  )
}
